import React, { Component } from 'react'
import { Row, Col, CardHeader, CardBody, Button, Input, InputGroup, InputGroupAddon, Table, Spinner, Badge } from 'reactstrap'
import { graphql, compose } from 'react-apollo'
import PropTypes from 'prop-types'
import { ProjectsDepth1Query, WpsListQuery, WpsAssignedToProjectQuery, assignWpsToProjectsMutation } from './mutations'

class WpsAssignProjects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectFilter: '',
      selectedProjectId: null,
      selectedProjectName: '',
      wpsFilter: '',
      selectedWpsIds: new Set(),
      assignedWpsIds: new Set(),
      saving: false,
    }
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    projectsData: PropTypes.object.isRequired,
    wpsData: PropTypes.object.isRequired,
    assignedData: PropTypes.object.isRequired,
    assignWpsToProjectsMutation: PropTypes.func.isRequired,
  }

  componentWillReceiveProps(next) {
    if (next.assignedData && !next.assignedData.loading && next.assignedData.wps_assigned_to_project) {
      const ids = new Set(next.assignedData.wps_assigned_to_project.map(Number))
      this.setState({ assignedWpsIds: ids, selectedWpsIds: new Set(ids) })
    }
  }

  selectProject(project) {
    this.setState({
      selectedProjectId: Number(project.id),
      selectedProjectName: project.name,
      selectedWpsIds: new Set(),
      assignedWpsIds: new Set(),
    }, () => {
      this.props.assignedData.refetch({ project_id: project.id })
    })
  }

  toggleWps(id) {
    this.setState(prev => {
      const next = new Set(prev.selectedWpsIds)
      next.has(id) ? next.delete(id) : next.add(id)
      return { selectedWpsIds: next }
    })
  }

  selectAll = (filtered) => {
    this.setState(prev => {
      const next = new Set(prev.selectedWpsIds)
      filtered.forEach(w => next.add(Number(w.id)))
      return { selectedWpsIds: next }
    })
  }

  deselectAll = (filtered) => {
    this.setState(prev => {
      const next = new Set(prev.selectedWpsIds)
      filtered.forEach(w => next.delete(Number(w.id)))
      return { selectedWpsIds: next }
    })
  }

  save = () => {
    if (!this.state.selectedProjectId) return
    this.setState({ saving: true })
    this.props.assignWpsToProjectsMutation({
      variables: {
        project_id: this.state.selectedProjectId,
        wps_ids: Array.from(this.state.selectedWpsIds),
      }
    }).then(() => {
      this.setState({ saving: false, assignedWpsIds: new Set(this.state.selectedWpsIds) })
    })
  }

  render() {
    const { projectsData, wpsData, assignedData } = this.props
    const { projectFilter, selectedProjectId, selectedProjectName,
      wpsFilter, selectedWpsIds, assignedWpsIds, saving } = this.state

    const projects = (projectsData.projects_depth1 || []).filter(p =>
      p.name.toLowerCase().includes(projectFilter.toLowerCase())
    )

    const allWps = wpsData.wps_list ? wpsData.wps_list.list : []
    const filteredWps = wpsFilter.trim()
      ? allWps.filter(w => w.no && w.no.toLowerCase().includes(wpsFilter.toLowerCase()))
      : allWps

    const allFilteredSelected = filteredWps.length > 0 && filteredWps.every(w => selectedWpsIds.has(Number(w.id)))

    const changedCount = (() => {
      let added = 0, removed = 0
      selectedWpsIds.forEach(id => { if (!assignedWpsIds.has(id)) added++ })
      assignedWpsIds.forEach(id => { if (!selectedWpsIds.has(id)) removed++ })
      return { added, removed }
    })()

    const loadingAssigned = assignedData && assignedData.loading

    return (
      <div>
        <CardHeader>
          <b>Assign WPS to project</b>
          <Button color="secondary" size="sm" className="float-right"
            onClick={() => this.props.history.push('/wps')}>
            <i className="fa fa-arrow-left" /> Back
          </Button>
        </CardHeader>
        <CardBody style={{ padding: 0 }}>
          <Row style={{ margin: 0 }}>

            {/* LEFT — projects */}
            <Col md="3" style={{ display: 'flex', flexDirection: 'column', borderRight: '1px solid #dee2e6', padding: '12px 8px' }}>
              <Input
                placeholder="Filter projects..."
                value={projectFilter}
                onChange={e => this.setState({ projectFilter: e.target.value })}
                style={{ marginBottom: 8 }}
              />
              {projectsData.loading
                ? <div className="text-center pt-3"><Spinner size="sm" /></div>
                : (
                  <div style={{ overflowY: 'auto', height: 'calc(100vh - 280px)' }}>
                    {projects.map(p => (
                      <div key={p.id}
                        onClick={() => this.selectProject(p)}
                        style={{
                          padding: '8px 12px',
                          cursor: 'pointer',
                          backgroundColor: selectedProjectId === Number(p.id) ? '#20a8d8' : 'transparent',
                          color: selectedProjectId === Number(p.id) ? '#fff' : 'inherit',
                          borderBottom: '1px solid #f0f0f0',
                        }}>
                        {p.name}
                      </div>
                    ))}
                  </div>
                )}
            </Col>

            {/* RIGHT — wps list */}
            <Col md="9" style={{ display: 'flex', flexDirection: 'column', padding: '12px 8px' }}>
              {!selectedProjectId
                ? <div className="text-muted pt-3 text-center">← Select a project to assign WPS</div>
                : (
                  <React.Fragment>
                    <div className="d-flex align-items-center mb-2" style={{ flexWrap: 'wrap', gap: 6 }}>
                      <InputGroup style={{ maxWidth: 300 }}>
                        <Input
                          placeholder="Filter by WPS No..."
                          value={wpsFilter}
                          onChange={e => this.setState({ wpsFilter: e.target.value })}
                        />
                        {wpsFilter && (
                          <InputGroupAddon addonType="append">
                            <Button color="secondary" onClick={() => this.setState({ wpsFilter: '' })}>
                              <i className="fa fa-times" />
                            </Button>
                          </InputGroupAddon>
                        )}
                      </InputGroup>

                      <Button size="sm" color="info"
                        onClick={() => allFilteredSelected ? this.deselectAll(filteredWps) : this.selectAll(filteredWps)}
                        disabled={filteredWps.length === 0}>
                        {allFilteredSelected ? 'Deselect all' : 'Select all'} ({filteredWps.length})
                      </Button>

                      <span className="text-muted" style={{ fontSize: 13 }}>
                        {selectedWpsIds.size} selected
                        {changedCount.added > 0 && <Badge color="success" className="ml-1">+{changedCount.added}</Badge>}
                        {changedCount.removed > 0 && <Badge color="danger" className="ml-1">-{changedCount.removed}</Badge>}
                      </span>

                      <Button color="primary" style={{ marginLeft: 'auto' }} onClick={this.save}
                        disabled={saving || (changedCount.added === 0 && changedCount.removed === 0)}>
                        {saving ? <Spinner size="sm" /> : <React.Fragment><i className="fa fa-save" /> Save for {selectedProjectName}</React.Fragment>}
                      </Button>
                    </div>

                    {wpsData.loading
                      ? <div className="text-center pt-4"><Spinner /></div>
                      : (
                        <div style={{ overflowY: 'auto', height: 'calc(100vh - 280px)' }}>
                          <Table bordered size="sm" style={{ marginBottom: 0 }}>
                            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                              <tr>
                                <th style={{ width: 36 }}></th>
                                <th>WPS No</th>
                                <th>Rev</th>
                                <th>Welding processes</th>
                                <th>Standard</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredWps.map(wps => {
                                const id = Number(wps.id)
                                const checked = selectedWpsIds.has(id)
                                const wasAssigned = assignedWpsIds.has(id)
                                return (
                                  <tr key={wps.id}
                                    onClick={() => this.toggleWps(id)}
                                    style={{
                                      cursor: 'pointer',
                                      backgroundColor: checked
                                        ? (wasAssigned ? 'transparent' : '#cce5ff')
                                        : (wasAssigned ? '#f8d7da' : 'transparent'),
                                    }}>
                                    <td className="text-center align-middle">
                                      <Input type="checkbox" checked={checked} onChange={() => this.toggleWps(id)}
                                        onClick={e => e.stopPropagation()}
                                        style={{ position: 'static', margin: 0 }} />
                                    </td>
                                    <td className="align-middle"><b>{wps.no}</b></td>
                                    <td className="align-middle">{wps.rev_no}</td>
                                    <td className="align-middle">{wps.welding_processes_names}</td>
                                    <td className="align-middle">{wps.standard && wps.standard.name}</td>
                                  </tr>
                                )
                              })}
                              {filteredWps.length === 0 && (
                                <tr><td colSpan={5} className="text-center text-muted py-3">No WPS found</td></tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                  </React.Fragment>
                )}
            </Col>
          </Row>
        </CardBody>
      </div>
    )
  }
}

export default compose(
  graphql(ProjectsDepth1Query, { name: 'projectsData' }),
  graphql(WpsListQuery, {
    name: 'wpsData',
    options: { fetchPolicy: 'network-only', variables: { page: 1, pageSize: 10000 } }
  }),
  graphql(WpsAssignedToProjectQuery, {
    name: 'assignedData',
    options: { variables: { project_id: 0 }, fetchPolicy: 'network-only' }
  }),
  graphql(assignWpsToProjectsMutation, { name: 'assignWpsToProjectsMutation' })
)(WpsAssignProjects)



// WEBPACK FOOTER //
// ./src/components/Wps/WpsAssignProjects.js